import React, { useEffect, useState } from 'react';
import {
  makeStyles,
  shorthands,
  tokens,
  Text,
  Button,
  Field,
  Dropdown,
  Option,
} from '@fluentui/react-components';

const useStyles = makeStyles({
  container: {
    display: 'flex',
    flexDirection: 'column',
    height: '100%',
  },
  content: {
    flex: 1,
    ...shorthands.padding('24px'),
    overflow: 'auto',
  },
  pricingContainer: {
    display: 'flex',
    flexDirection: 'column',
    gap: '24px',
  },
  pricingRow: {
    display: 'flex',
    gap: '16px',
    alignItems: 'flex-end',
  },
  pricingField: {
    flex: 1,
  },
  exampleBox: {
    backgroundColor: tokens.colorNeutralBackground4,
    ...shorthands.padding('16px'),
    ...shorthands.borderRadius('4px'),
    marginTop: '16px',
  },
  exampleLabel: {
    fontSize: '12px',
    fontWeight: '600',
    marginBottom: '4px',
  },
  exampleValue: {
    fontSize: '18px',
    fontWeight: '600',
  },
  settingsSection: {
    backgroundColor: tokens.colorNeutralBackground1,
    ...shorthands.borderRadius('4px'),
    ...shorthands.padding('24px'),
    boxShadow: tokens.shadow8,
  },
  sectionTitle: {
    fontSize: '18px',
    fontWeight: '600',
    marginBottom: '16px',
  },
  formFields: {
    display: 'flex',
    flexDirection: 'column',
    gap: '16px',
  },
  pricingButtonSection: {
    display: 'flex',
    justifyContent: 'flex-end',
    marginTop: '16px',
  },
  openBooqableButton: {
    marginTop: '8px',
  },
});

const SettingsPricing: React.FC = () => {
  const styles = useStyles();
  const [currency, setCurrency] = useState('United States Dollar');
  const [displayCurrency, setDisplayCurrency] = useState('Symbol ($)');
  const [currencyPosition, setCurrencyPosition] = useState('Before amount');

  useEffect(() => {
    window.dispatchEvent(new CustomEvent('setPageContext', {
      detail: { title: 'Pricing' },
    }));
    return () => {
      window.dispatchEvent(new CustomEvent('setPageContext', { detail: null }));
    };
  }, []);

  return (
    <div className={styles.container}>
      <div className={styles.content}>
        <div className={styles.pricingContainer}>
          {/* General Section */}
          <div className={styles.settingsSection}>
            <Text className={styles.sectionTitle}>General</Text>
            <div className={styles.formFields}>
              <Field label="Currency">
                <Dropdown
                  value={currency}
                  onOptionSelect={(e, data) => setCurrency(data.optionText || 'United States Dollar')}
                >
                  <Option>United States Dollar</Option>
                  <Option>Euro</Option>
                  <Option>British Pound</Option>
                </Dropdown>
              </Field>

              <div className={styles.pricingRow}>
                <Field label="Display currency as" className={styles.pricingField}>
                  <Dropdown
                    value={displayCurrency}
                    onOptionSelect={(e, data) => setDisplayCurrency(data.optionText || 'Symbol ($)')}
                  >
                    <Option>Symbol ($)</Option>
                    <Option>Code (USD)</Option>
                    <Option>Name (Dollar)</Option>
                  </Dropdown>
                </Field>

                <Field label="Currency position" className={styles.pricingField}>
                  <Dropdown
                    value={currencyPosition}
                    onOptionSelect={(e, data) => setCurrencyPosition(data.optionText || 'Before amount')}
                  >
                    <Option>Before amount</Option>
                    <Option>After amount</Option>
                  </Dropdown>
                </Field>
              </div>

              <div className={styles.exampleBox}>
                <div className={styles.exampleLabel}>Example</div>
                <div className={styles.exampleValue}>$125.99</div>
              </div>
            </div>

            <div className={styles.pricingButtonSection}>
              <Button appearance="primary">Save</Button>
            </div>
          </div>

          {/* Pricing structure templates */}
          <div className={styles.settingsSection}>
            <Text className={styles.sectionTitle}>Pricing structure templates</Text>
            
          </div>

          {/* Advanced pricing */}
          <div className={styles.settingsSection}>
            <Text className={styles.sectionTitle}>Advanced pricing</Text>
            
          </div>

          {/* Coupon codes */}
          <div className={styles.settingsSection}>
            <Text className={styles.sectionTitle}>Coupon codes</Text>
            
          </div>

          {/* Security deposits */}
          <div className={styles.settingsSection}>
            <Text className={styles.sectionTitle}>Security deposits</Text>
          </div>
        </div>
      </div>
    </div>
  );
}

export default SettingsPricing;